<div class="simple-page-template tw-w-full">
  <div class="breadcrumbs">
    <ng-content select="[breadcrumbs]"></ng-content>
  </div>
  <div class="title">
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="body">
    <div class="simple-page-template__card tw-p-5">
      <ng-content select="[card]"></ng-content>
    </div>
    <nz-divider></nz-divider>
    <div class="footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
